import {stringToAttributeId} from '../components/spc/util/spcUtils';

export function getProductData(attributeKey, productData) {
	console.log('getProductData', attributeKey, productData);
	if (!productData) return null;
	return productData.find(
		attribute => attribute.globalAttributeId === stringToAttributeId(attributeKey).localId
	);
}
